module.exports = __webpack_public_path__ + "static/media/flooring_gwp_60y_n.ce66bffa.csv";